"use strict";
/**
 * Order Toggle
 * Handles expanding/collapsing order details on the account page
 */
Object.defineProperty(exports, "__esModule", { value: true });
function orderToggle() {
    var toggleButtons = document.querySelectorAll('.account-order__toggle');
    toggleButtons.forEach(function (button) {
        var detailsDiv = button.nextElementSibling;
        if (!detailsDiv)
            return;
        button.addEventListener('click', function () {
            var isActive = button.classList.contains('active');
            var viewItemsText = button.getAttribute('data-view-text') || 'View items';
            var hideItemsText = button.getAttribute('data-hide-text') || 'Hide items';
            console.log({ isActive: isActive });
            if (isActive) {
                button.classList.remove('active');
                detailsDiv.style.display = 'none';
                button.textContent = viewItemsText;
            }
            else {
                button.classList.add('active');
                detailsDiv.style.display = 'block';
                button.textContent = hideItemsText;
            }
        });
    });
}
exports.default = orderToggle;
